import { useCallback,useState } from 'react';
import { BAG_FIRST } from '../bagFirst';
import { closetPhotoNebi } from './ClosetPicker';
import { uberFee, uberFeeNormal, uberFeeCaption } from './uberFee';

// 顧客が負担するUber配達手数料は「サーバが返す値」が唯一の正。
// order/quote.php が quote.uber_fee（実際に請求する額）と quote.uber_fee_normal（無料でなければいくらか）
// を返すので、アプリ側には金額を一切書かない。
// 2026-10-01の2段階制改定（2kmまで990円／2km超〜3km 1,490円／ロッカー・店頭0円）も
// サーバ設定(app_settings.uber_fee_config)だけで切り替わり、この画面は触らなくてよい。
// ※旧バージョンのAPIと混在した場合に0円請求にならないよう、値が無いときだけ旧既定の490を使う。
export { uberFee, uberFeeNormal, uberFeeCaption };

export const CalcGoukei = (data, setSyoukei, setGoukei) => {
  // console.log(data);
  const calcGoukei = useCallback(() => {
    let tmp_goukei = Number(data.item.kin2);
    if (data.options !== undefined && data.options.length > 0) {
      data.options.forEach(option => {
        tmp_goukei += Number(option.kin2) * Number(option.suu);
      });
    }
    setSyoukei(tmp_goukei);
    if (data.coupon !== undefined) {
      tmp_goukei -= Number(data.coupon.kingaku);
    }
    // お気に入りクローゼットの撮影割引（サーバと同じく、クーポンと合わせて引いてから0円で止める）
    tmp_goukei -= closetPhotoNebi(data);
    if (tmp_goukei < 0) {
      tmp_goukei = 0;
    }
    tmp_goukei += uberFee(data);
    setGoukei(tmp_goukei);
  }, [data, setSyoukei, setGoukei]);

  return calcGoukei;
};

export const ConfirmOrder = (data, syoukei, goukei) => {
  const [expandedOptions, setExpandedOptions] = useState({});
  return (
  <>
    <div className="row mb-2">
      <div className="col-8">
        {data.item.name}
      </div>
      <div className="col-4 text-right">
        ¥{Number(data.item.kin2).toLocaleString()}
      </div>
    </div>
    {/* bag-first: この注文には専用バッグの無料お届けが含まれる。
        「990円のほかにバッグ代も要るのでは」という不安をここで消す。 */}
    {BAG_FIRST && Number(data.quote?.is_bag_first) === 1 && (
      <div className="row mb-2">
        <div className="col-8">
          専用バッグ<span className="text-danger">(初回無料)</span>
        </div>
        <div className="col-4 text-right">
          ¥0
        </div>
      </div>
    )}
    {data.options !== undefined && data.options.length>0 && (
      <>
        {data.options.map((option,key) =>
          <div key={key}>
            <div className="row mb-2">
              <div className="col-8">
              {option.images?.length > 0 ? (
                <>
                  <span
                    className="text-primary"
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() =>
                      setExpandedOptions(prev => ({
                        ...prev,
                        [option.id]: !prev[option.id],
                      }))
                    }
                  >
                    {option.name}
                  </span> x {option.suu}
                </>
              ) : (
                <>
                  {option.name} x {option.suu}
                </>
              )}
              </div>
              <div className="col-4 text-right">
                ¥{Number(option.kin2 * option.suu).toLocaleString()}
              </div>
            </div>
            {option.images?.length > 0 && (
              <div className="">
                <div
                  className={`option-image-list ${expandedOptions[option.id] ? 'open' : ''}`}
                >
                  <div className="row mt-2">
                    {option.images.map((img, imgIndex) => (
                      <div key={imgIndex} className="col-4 mb-2">
                        <img
                          src={typeof img === 'string' ? img : URL.createObjectURL(img.file)}
                          className="OptionImage img-fluid rounded shadow-sm"
                          alt="オプション画像"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </>
    )}
    <div className="mb-2 border-bottom"></div>
    <div className="row mb-2">
      <div className="col-8">
        <strong>小計</strong>
      </div>
      <div className="col-4 text-right">
        ¥{Number(syoukei).toLocaleString()}
      </div>
    </div>
    {data.coupon !== undefined && (
      <div className="row mb-2">
        <div className="col-8 text-danger">
          クーポン
        </div>
        <div className="col-4 text-right text-danger">
          -¥{Number(data.coupon.kingaku).toLocaleString()}
        </div>
      </div>
    )}
    {closetPhotoNebi(data) > 0 && (
      <div className="row mb-2">
        <div className="col-8 text-danger">
          撮影割引（{(data.closet_items || []).filter((it) => Number(it.photo_discount) > 0).length}点）
        </div>
        <div className="col-4 text-right text-danger">
          -¥{closetPhotoNebi(data).toLocaleString()}
        </div>
      </div>
    )}
    {/* 配達手数料。金額はすべてサーバ値（uberFee / uberFeeNormal）から取る。 */}
    {data.item.id==='0' ? (
      <>
      </>
    ) : data.user_dropoff_type==='own' ?  (
        <></>
    ) : uberFee(data) === 0 ? (
      <div>
        <div className="row mb-2">
          <div className="col-8">
            <strong>Uber配達手数料</strong>
          </div>
          <div className="col-4 text-right">
            ¥{uberFeeNormal(data).toLocaleString()}
          </div>
        </div>
        <div className="row mb-2 text-danger h6">
          <div className="col-8">
            →初回無料！
          </div>
          <div className="col-4 text-right">
            -¥{uberFeeNormal(data).toLocaleString()}
          </div>
        </div>
      </div>
    ) : data.item.type==='futon_bag' ?  (
      <div className="row mb-2">
        <div className="col-8">
          {uberFeeCaption(data).discounted
            ? <>{uberFeeCaption(data).text}<span className="text-danger">{uberFee(data).toLocaleString()}円</span>）</>
            : uberFeeCaption(data).text}
        </div>
        <div className="col-4 text-right">
          ¥{uberFee(data).toLocaleString()}
        </div>
      </div>
    ):(
      <div className="row mb-2">
        <div className="col-8">
          {uberFeeCaption(data).discounted
            ? <>{uberFeeCaption(data).text}<span className="text-danger">{uberFee(data).toLocaleString()}円</span>）</>
            : uberFeeCaption(data).text}
        </div>
        <div className="col-4 text-right">
          ¥{uberFee(data).toLocaleString()}
        </div>
      </div>
    )}

    <div className="mb-2 border-bottom"></div>
    <div className="row">
      <div className="col-6 h5">
        合計
      </div>
      <div className="col-6 text-right h4">
        ¥{goukei.toLocaleString()}
      </div>
    </div>
  </>);
}


export const ConfirmOption = (data, syoukei) => {
  return (
  <>
    <div className="row mb-2">
      <div className="col-8">
        {data.item.name}
      </div>
      <div className="col-4 text-right">
        ¥{Number(data.item.kin2).toLocaleString()}
      </div>
    </div>
    {data.options !== undefined && data.options.length>0 && (
      <>
        {data.options.map((option,key) =>
          <div className="row mb-2" key={key}>
            <div className="col-8">
              {option.name} x {option.suu}
            </div>
            <div className="col-4 text-right">
              ¥{Number(option.kin2 * option.suu).toLocaleString()}
            </div>
          </div>
        )}
      </>
    )}

    <div className="mb-2 border-bottom"></div>
    <div className="row">
      <div className="col-12 text-right h4">
        <span className="mr-2">合計</span>¥{syoukei.toLocaleString()}
      </div>
    </div>
    <div className="row">
      <div className="col-12 text-right">
        <small>※別途配達手数料が加算されます</small>
      </div>
    </div>
  </>);
}
